import { createFileRoute } from "@tanstack/react-router";
import Ambarcatiuni from "@/pages/Ambarcatiuni";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/ambarcatiuni/")({
  head: () => routeHead("/de/ambarcatiuni/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Ambarcatiuni />
  );
}
